import type { QueryPreviewProps } from './use-query-preview';
import { useQueryPreview } from './use-query-preview';

export function QueryPreview(props: QueryPreviewProps) {
  const f = useQueryPreview(props);

  return (
    <div className="space-y-2">
      {!props.hideHeading && (
        <h3 className="text-sm font-semibold">Query Preview</h3>
      )}
      <pre className="font-mono text-sm bg-muted p-4 rounded overflow-x-auto">
        <code>{f.code}</code>
      </pre>
    </div>
  );
}
